import { initOutputDateRange } from 'src/common/page/PageConfigProvider/constants/initOutputDateRange';
import { FilterFields, FilterFieldsKeys } from '../types/FilterFields';
import { Currency } from 'src/common/types/Currency';

export const initFields: FilterFields = {
  [FilterFieldsKeys.CreationTime]: initOutputDateRange,
  [FilterFieldsKeys.LastModifiedTime]: initOutputDateRange,
  [FilterFieldsKeys.OrderId]: '',
  [FilterFieldsKeys.PfhNo]: '',
  [FilterFieldsKeys.ClientName]: '',
  [FilterFieldsKeys.CreditCurrency]: {} as Currency,
};
